import { type AttributeFilter } from '@/generated'

export const getLabelFromSelectedValue = (
  value: string,
  filterOptions: AttributeFilter['values']
) => {
  const selectedOption = filterOptions?.find((option) => value === option.value)
  return selectedOption && selectedOption.label
}
